// extracted by mini-css-extract-plugin
export var actionButton = "_f0-0";
export var fileInput = "_f0-2";
export var paperclip = "_f0-1";